// Klang der Harmonika in der Webapp: angeklickte Knöpfe (`HarmonikaButton`, `BassBoard`), die
// Hörproben des Akkord-Finders und der Simulator (`useHarmonikaAudio`). Alle teilen EINE AudioEngine
// je Tab: je Knopf oder View ein AudioContext sprengte Chromes Limit pro Tab. Sie entsteht erst beim
// ersten Ton – vor einer Nutzergeste startete der Context „suspended“ – und wird nie geschlossen.

import {useSettingsStore} from '@/stores/settings'

import {AudioEngine} from './AudioEngine'
import {midiToFreq} from './noteParse'

let engine: AudioEngine | null = null
let toneCounter = 0

export function sharedAudioEngine(): AudioEngine {
  return (engine ??= new AudioEngine())
}

/**
 * Startet die Töne (MIDI im G-C-F-B-Raum, klingend in der Stimmung der eigenen Harmonika) und gibt
 * die Funktion zurück, die sie wieder beendet. Doppelte MIDI-Werte klingen einmal – enharmonische
 * Dubletten der Knopftabelle sonst doppelt so laut.
 */
export function startButtonTones(midis: Iterable<number>): () => void {
  const audio = sharedAudioEngine()
  const offset = useSettingsStore().instrumentTuningOffset
  const ids = [...new Set(midis)].map((midi) => {
    const id = `button-tone-${(toneCounter += 1)}`
    audio.playNote(midiToFreq(midi + offset), id)
    return id
  })
  return () => ids.forEach((id) => audio.stopNote(id))
}

/** Spielt die Töne für `durationMs`, beginnend nach `delayMs` – ohne gehaltenen Knopf. */
export function playButtonTones(midis: Iterable<number>, durationMs: number, delayMs = 0): void {
  setTimeout(() => {
    const stop = startButtonTones(midis)
    setTimeout(stop, durationMs)
  }, delayMs)
}
